$(document).ready(function(){
   
  var product_id,variant_id,available;
  product_id = $.trim($('.product_id').html());
  variant_id=$.trim($('.variant_id').html());
  //alert("product_id="+ product_id + "variant_id="+ variant_id );
  function getInventoryInfo (product_id,variant_id){
    
  $.ajax({
    type: 'POST',
    url: 'http://noragardner.co/ngshopifystore/Nora-inventory/Nora_check_inventory.php?product_id='+product_id+'&variant_id='+variant_id,
    async: false,
    dataType: 'json',
    success: function(response) {
    //  console.log(response);
      var locationId=new Array();
      response=$.parseJSON(response);
      console.log(response);
       $('.dynamic-inventory').hide();
      var chkLocation = 0;
      var locationName=['Pre Orders','Southern Kentucky Warehouse',"Southern Kentucky Warehouse"];
      $.each(response['inventory_levels'], function(index, value) {
        //console.log(response['inventory_levels'][index]['location_id']) ;
       var locationId2=response['inventory_levels'][index]['location_id'];
		available=parseInt(response['inventory_levels'][index]['available']);
       locationId.push({"location_id" :response['inventory_levels'][index]['location_id'], "available" : available });
        
        if(locationId2 == 5522128990 && available > 0){
         // $('.dynamic-inventory').show();
        }
      }); 
      
   //console.log(locationId);
        $('.dynamic-inventory').hide();
      var flag = false;
       $.each(locationId, function(index, value) {
         //console.log(value)
            if(value.location_id != 5522128990 && value.available > 0){             
               flag = true;
            }
             if(value.location_id == 5522128990 && value.available > 0 && flag==false){
              $('.dynamic-inventory').show();
            }
       });
      if(flag== true){
        $('.dynamic-inventory').hide();
      }
    }

  });
  }
  
  if($('.skw_shipping_text').length > 0){
  getInventoryInfo (product_id,variant_id); // get inventory on page load
  }
  
  document.addEventListener('variant:change', function(e) {
       console.log(e);
      if($('.skw_shipping_text').length > 0 && e.detail.variant != null){
    getInventoryInfo (product_id,e.detail.variant.id);
      }else{
         if($('.skw_shipping_text').length > 0){
        getInventoryInfo (product_id,variant_id); // get inventory on page load
        }
      }
  });
});